export default [
    {
        key: "tumba",
        allArray: "allTumbaStoyka",
        activeArray: "activeTumbaStoyka",
        position: "bottom",
    },
];
